import { createReducer } from '@reduxjs/toolkit'

import { Field, selectCurrency, setRecipient, switchCurrencies, typeInput } from './actions'

export interface MentoState {
  readonly independentField: Field
  readonly typedValue: string
  readonly [Field.INPUT]: {
    readonly currencyId: string | undefined
  }
  readonly [Field.OUTPUT]: {
    readonly currencyId: string | undefined
  }
  // the typed recipient address or ENS name, or null if swap should go to sender
  readonly recipient: string | null
}

const initialState: MentoState = {
  independentField: Field.OUTPUT,
  typedValue: '',
  [Field.INPUT]: {
    currencyId: '0x471EcE3750Da237f93B8E339c536989b8978a438',
  },
  [Field.OUTPUT]: {
    currencyId: '0x765DE816845861e75A25fCA122bb6898B8B1282a',
  },
  recipient: null,
}

export default createReducer<MentoState>(initialState, (builder) =>
  builder
    .addCase(selectCurrency, (state, { payload: { currencyId, field } }) => {
      const otherField = field === Field.INPUT ? Field.OUTPUT : Field.INPUT
      if (currencyId === state[otherField].currencyId) {
        // the case where we have to swap the order
        return {
          ...state,
          independentField: state.independentField === Field.INPUT ? Field.OUTPUT : Field.INPUT,
          [field]: { currencyId: currencyId },
          [otherField]: { currencyId: state[field].currencyId },
        }
      } else {
        // the normal case
        if (!!state[Field.INPUT].currencyId && !!state[Field.OUTPUT].currencyId) {
          return {
            ...state,
            [otherField]: {
              currencyId: undefined,
            },
            [field]: {
              currencyId: currencyId,
            },
          }
        }
        return {
          ...state,
          [field]: { currencyId: currencyId },
        }
      }
    })
    .addCase(switchCurrencies, (state) => {
      return {
        ...state,
        independentField: state.independentField === Field.INPUT ? Field.OUTPUT : Field.INPUT,
        [Field.INPUT]: { currencyId: state[Field.OUTPUT].currencyId },
        [Field.OUTPUT]: { currencyId: state[Field.INPUT].currencyId },
      }
    })
    .addCase(typeInput, (state, { payload: { field, typedValue } }) => {
      return {
        ...state,
        independentField: field,
        typedValue,
      }
    })
    .addCase(setRecipient, (state, { payload: { recipient } }) => {
      state.recipient = recipient
    })
)
